export default {"src":"/_next/static/media/lock_svgrepo.com.9e73e79a.svg","height":16,"width":13,"blurWidth":0,"blurHeight":0};